exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".field[data-v-3cfd26dc] {\n  margin-top: 20px;\n  margin-bottom: 15px;\n}\n.field label[data-v-3cfd26dc] {\n  font-size: 14px;\n  font-weight: 500;\n  display: block;\n  margin-bottom: 5px;\n}\n.field .required[data-v-3cfd26dc] {\n  font-weight: 600;\n}\n.field .required[data-v-3cfd26dc]:after {\n  content: \" *\";\n  color: #dc3545; /* Bootstrap's danger color */\n}\n.loader[data-v-3cfd26dc] {\n  color: #007bff; /* Bootstrap's primary color */\n}\n[data-v-3cfd26dc] .modal-dialog {\n  max-width: 800px;\n}", ""]);

// exports
